module.exports = __webpack_public_path__ + "d4a9b15ca6bf734bd9a531c49f661edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/servant3.png
// module id = 1089
// module chunks = 3